import React, {useRef, useState} from 'react';
import { BASE_API } from '../../api/Globals';
import ReCAPTCHA from "react-google-recaptcha";
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import MessageTop from '../../components/sturtural/MessageTop';
import MessageDetail from '../../components/sturtural/MessageDetail';
import { helpHttp } from "../../helpers/helpHttp";
import Loader from '../../components/sturtural/Loader';
import { Toast } from 'primereact/toast';
import { useNavigate } from 'react-router-dom'

const initialForm = {
    nombre: "",
    apellido1: "",
    apellido2: "",
    telefono: "",
    correo_electronico: "",
    contraseña: "",
    confirmar_contraseña: ""
}

const validationsFrom = (form) => {
    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    //let regexEmail = /^(\w+[/./-]?){1,}@[a-z]+[/.]\w{2,}$/;
    let regexEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
    //let regexComments = /^.{1,255}$/;
    let regexDigitos = /^.{1,10}$/;
    let regexNumbers = /^([0-9])*$/;

    if(!form.nombre.trim()) {
        errors.nombre = "El Campo (Nombre) es requerido";
    } else if(!regexName.test(form.nombre.trim())){
        errors.nombre = "El Campo (Nombre) es sólo acepta letras y espacios en blanco";
    }

    if(!form.apellido1.trim()) {
        errors.apellido1 = "El Campo (Primer apellido) es requerido";
    } else if(!regexName.test(form.apellido1.trim())){
        errors.apellido1 = "El Campo (Primer apellido) es sólo acepta letras y espacios en blanco";
    }

    if(!form.telefono.trim()) {
        errors.telefono = "El Campo (Teléfono) es requerido";
    } else if(!regexNumbers.test(form.telefono.trim())) {
        errors.telefono = "El Campo (Teléfono) acepta sólo números";
    } else if(!regexDigitos.test(form.telefono.trim())) {
        errors.telefono = "El Campo (Teléfono) acepta hasta 10 dígitos";
    }

    if(!form.correo_electronico.trim()) {
        errors.correo_electronico = "El Campo (Correo electrónico) es requerido";
    } else if(!regexEmail.test(form.correo_electronico.trim())){
        errors.correo_electronico = "El Campo (Correo electrónico) es incorrecto";
    }

    if(!form.contraseña.trim()) {
        errors.contraseña = "El Campo (Contraseña) es requerido";
    }

    if(!form.confirmar_contraseña.trim()) {
        errors.confirmar_contraseña = "El Campo (Confirmar contraseña) es requerido";
    }

    if(form.contraseña.trim() !== form.confirmar_contraseña.trim()) {
        errors.igual_contraseña = "Los campos Contraseña y Confirmar contraseña deben ser iguales.";
    }
    return errors;
}

const Profile = () => {
    const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(null);
    const navigate = useNavigate()

    const captcha = useRef(null);
    const toast = useRef(null);

    const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validationsFrom(form));
	};

	/*const onChange = () => {
		if(captcha.current.getValue()){
			console.log('El usuario no es un robot');
			//cambiarCaptchaValido(true);
		}
	}*/

    const handleResponse = () => {
        setResponse(false);
        showToast('error', 'Error de captcha', 'Favor de aceptar el captcha');
    }

    const showToast = (severity, summary, detail ) => {
        toast.current.show({ 
            severity: severity, 
            summary: summary, 
            detail: detail, 
            life: 5000 
        });
    };


    const handleSubmit = (e) => {
		e.preventDefault();

		if(captcha.current.getValue()){
            
            setErrors(validationsFrom(form));

            if (Object.keys(errors).length === 0) {

                const arrUser = {
                    nombre: form.nombre,
                    primer_apellido: form.apellido1,
                    segundo_apellido: form.apellido2,
                    correo_electronico: form.correo_electronico,
                    telefono: form.telefono,
                    password: form.contraseña,
                    sistemaid: 3,
                    rolid: 1
                };

                setLoading(true);

                helpHttp().post(`${BASE_API}user/signupexternal`, {
                    body: arrUser,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Access-Control-Allow-Origin': '*'
                    },
                    })
                    .then((res) => {
                        if(res.response === 'on') {
                            navigate("/correo-confirmacion");
                        } else if(res.response === 'off') {
                            setResponse(res.message)
                            setLoading(false);
                        }
                    });
            } else {
                showToast('info', 'Mensaje: Formulario y captcha', 'No eres un robot, pero recuerda que todos los campos estan validados');
                return;
            }
        } else {
			console.log('Por favor acepta el captcha');
            showToast('error', 'Error de captcha', 'Favor de verificar el captcha');
		}
	};

    return (
        <div className="grid">
            <Toast ref={toast} />

            <form onSubmit={handleSubmit} className="col-12">
                <div className="card">
                    <h3>Perfil de Usuario</h3>
                    <div className="p-fluid formgrid grid">
                        <div className="field col-12 md:col-12">
                            <label htmlFor="avatar" className="font-medium">Fotografia:</label>
                            <div className="flex align-items-center">
                                <img src="assets/layout/images/users/user.png" alt="avatar-f-4" className="mr-4" style={{ width: "70px", height: "75px"}} />
                                <div className="p-fileupload p-fileupload-basic p-component">
                                    <div><div></div></div>
                                    <input type="file" className="form-control" id="fileinput" aria-label="Upload" accept="application/pdf" />
                                </div>
                            </div>
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="nombre">Nombre:</label>
                            <InputText id="nombre" name="nombre" type="text" value={form.nombre.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.nombre && 'p-invalid'} autoFocus />
                            {errors.nombre && <small className="p-error">{errors.nombre}</small>}
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="apellido1">Primer apellido:</label>
                            <InputText id="apellido1" name="apellido1" type="text" value={form.apellido1.toUpperCase()} onChange={handleChange} onBlur={handleBlur} className={errors.apellido1 && 'p-invalid'} />
                            {errors.apellido1 && <small className="p-error">{errors.apellido1}</small>}
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="apellido2">Segundo apellido:</label>
                            <InputText id="apellido2" name="apellido2" type="text" value={form.apellido2.toUpperCase()} onChange={handleChange} onBlur={handleBlur} />
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="telefono">Teléfono:</label>
                            <InputText id="telefono" name="telefono" type="text" value={form.telefono} onChange={handleChange} onBlur={handleBlur} className={errors.telefono && 'p-invalid'} />
                            {errors.telefono && <small className="p-error">{errors.telefono}</small>}
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="correo_electronico">Correo electrónico:</label>
                            <InputText id="correo_electronico" name="correo_electronico" type="email" value={form.correo_electronico.toLowerCase()} onChange={handleChange} onBlur={handleBlur} className={errors.correo_electronico && 'p-invalid'} />
                            {errors.correo_electronico && <small className="p-error">{errors.correo_electronico}</small>}
                        </div>
                        
                        <div className="field col-12 md:col-4">
                            <label htmlFor="contraseña">Contraseña:</label>
                            <InputText id="contraseña" name="contraseña" type="password" value={form.contraseña} onChange={handleChange} onBlur={handleBlur} className={errors.contraseña && 'p-invalid'} />
                            {errors.contraseña && <small className="p-error">{errors.contraseña}</small>}
                        </div>
                        <div className="field col-12 md:col-4">
                            <label htmlFor="confirmar_contraseña">Confirmar contraseña:</label>
                            <InputText id="confirmar_contraseña" name="confirmar_contraseña" type="password" value={form.confirmar_contraseña} onChange={handleChange} onBlur={handleBlur} className={errors.confirmar_contraseña && 'p-invalid'} />
                            {errors.confirmar_contraseña && <><small className="p-error">{errors.confirmar_contraseña}</small><br /></>}
                            {errors.igual_contraseña && <small className="p-error">{errors.igual_contraseña}</small>}
                        </div>
                    </div>
                </div>  

                <div className="card">
                    {loading && <div><Loader /></div>}
                    {response && <MessageDetail mensaje={response} color="warn" /> }
                    <Button type="submit" value="Enviar" label="Guardar y continuar" icon="pi pi-user" className="w-full p-button-rounded" />
                </div>     
            </form>
        </div>
    )
}

export default Profile;